<script>
import { useCommonDevicesStore } from "@/store/modules/devices/common"
import { useGroupsStore } from "@/store/modules/groups"

export default {
  name: "TransformationFunctionUsage",
  props: {
    transformationFunction: {
      type: Object,
      required: true
    }
  },
  setup() {
    const commonDevicesStore = useCommonDevicesStore()
    const groupsStore = useGroupsStore()
    return { commonDevicesStore, groupsStore }
  },
  data() {
    return {
      devices: [],
      groups: []
    }
  },
  watch: {
    "transformationFunction.transformationId": {
      handler() {
        if (this.transformationFunction.usageDetail.deviceId.length) {
          this.loadDevices()
        }
        if (this.transformationFunction.usageDetail.deviceGroupId.length) {
          this.loadGroups()
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadDevices() {
      const res = await this.commonDevicesStore.getDevicesByFilter({
        "deviceId[in]": this.transformationFunction.usageDetail.deviceId.join(",")
      })
      this.devices = res.data
    },
    async loadGroups() {
      const res = await this.groupsStore.getGroupsByIds(this.transformationFunction.usageDetail.deviceGroupId)
      this.groups = res.data
    }
  }
}
</script>

<template>
  <div>
    <div class="mb-4">
      {{ $t("TRANSFORMATION_FUNCTION_USAGE") }}
    </div>
    <div class="d-flex gap-2">
      <!--DEVICES-->
      <div class="w-25">
        <div class="font-weight-bold">
          {{ $t("devices") }}
        </div>
        <div v-if="devices.length" class="box-white border-radius">
          <div v-for="device in devices" :key="device.custDestId" class="d-flex justify-content-between">
            <RouterLink
              :to="{
                name: device.deviceProtocol === 'LoRa' ? 'device' : `${device.deviceProtocol.toLowerCase()}Device`,
                params: { id: device.deviceId, customerId: device.customerId, projectId: device.projectId }
              }"
              class="link-gray font-weight-bolder"
            >
              <span>
                {{ device.custDeviceName }}
              </span>
            </RouterLink>
            <span>{{ device.deviceProtocol }}</span>
          </div>
        </div>
        <div v-else class="gray-text">
          {{ $t("TF_NO_DEVICES") }}
        </div>
      </div>

      <!--PAYLOAD-->
      <div class="w-25">
        <div class="font-weight-bold">
          {{ $t("PAYLOAD_TRANSFORMATION") }}
        </div>
        <div v-if="transformationFunction.usageDetail.hwDeviceId.length" class="box-white border-radius">
          <div
            v-for="hwDeviceId in transformationFunction.usageDetail.hwDeviceId"
            :key="hwDeviceId"
            class="d-flex justify-content-between"
          >
            <span>{{ hwDeviceId }}</span>
          </div>
        </div>
        <div v-else class="gray-text">
          {{ $t("TF_NO_DEVICES") }}
        </div>
      </div>

      <!--GROUPS-->
      <div class="w-25">
        <div class="font-weight-bold">
          {{ $t("DATAFLOW") }}
        </div>
        <div v-if="groups.length" class="box-white border-radius">
          <div v-for="group in groups" :key="group.deviceGroupId" class="d-flex justify-content-between">
            <RouterLink
              :to="{
                name: 'group',
                params: { id: group.deviceGroupId }
              }"
              class="link-gray font-weight-bolder"
            >
              <span>
                {{ group.deviceGroupName }}
              </span>
            </RouterLink>
          </div>
        </div>
        <div v-else class="gray-text">
          {{ $t("TF_NO_GROUPS") }}
        </div>
      </div>

      <!--ENDPOINTS-->
      <div class="w-25">
        <div class="font-weight-bold">
          {{ $t("ENDPOINT") }}
        </div>
        <div v-if="transformationFunction.usageDetail.custDestId.length" class="box-white border-radius">
          <div
            v-for="endpointId in transformationFunction.usageDetail.custDestId"
            :key="endpointId"
            class="d-flex justify-content-between"
          >
            <span>
              {{ endpointId }}
            </span>
          </div>
        </div>
        <div v-else class="gray-text">
          {{ $t("TF_NO_ENDPOINTS") }}
        </div>
      </div>
    </div>
  </div>
</template>
